import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { Button, DialogContentText, Divider, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import moment from 'moment';
import Loader from '../../elements/loader';
import Config from '../../config/index';
const axios = require('axios');
axios.defaults.headers.common['Authorization'] = localStorage.getItem('user_token');

const roles = [
    { value: 'admin', label: 'Admin' },
    { value: 'teacher', label: 'Teacher' },
    { value: 'student', label: 'Student' },
    { value: 'parents', label: 'Parent' },
];
const roleLabel = (value) => {
    const found = roles.find(role => role.value === value);
    return found ? found.label : value;
};

// "Login as" tab of tenant profile - log in to tenant as any user without password / two-factor code
class LoginAs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            role: 'admin',
            search: '',
            page: 0,
            perPage: 20,
            total: 0,
            users: [],
            isLoading: false,
            manualRole: 'admin',
            manualUsername: '',
            confirmUser: null,
            reason: '',
            reasonError: '',
            isSubmitting: false,
            logs: [],
            logRole: '',
            logSearch: '',
        };
        this.searchTimer = null;
    }
    componentDidMount() {
        this.loadUsers();
        this.loadLogs();
    }
    componentWillUnmount() {
        clearTimeout(this.searchTimer);
    }
    handleError = (error, message) => {
        if (error.response && error.response.status === 401) {
            localStorage.setItem('logout', true);
            window.location = '/';
            return;
        }
        if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
        }
        this.props.enqueueSnackbar(message, { variant: 'error' });
    }
    loadUsers = () => {
        let self = this;
        this.setState({ isLoading: true });
        const params = { role: this.state.role, search: this.state.search, page: this.state.page + 1, per_page: this.state.perPage };
        axios.get(Config.apiBaseURL + '/tenant/impersonate_users/' + this.props.tenantId, { params: params })
        .then(response => {
            self.setState({ users: response.data.users, total: response.data.total });
        })
        .catch(function (error) {
            self.setState({ users: [], total: 0 });
            self.handleError(error, 'Error! While loading users.');
        })
        .then(function () {
            self.setState({ isLoading: false });
        });
    }
    loadLogs = () => {
        let self = this;
        axios.get(Config.apiBaseURL + '/tenant/impersonate_logs/' + this.props.tenantId)
        .then(response => {
            self.setState({ logs: response.data });
        })
        .catch(function (error) {
            self.handleError(error, 'Error! While loading login history.');
        });
    }
    handleRoleChange = (event) => {
        this.setState({ role: event.target.value, page: 0, search: '' }, this.loadUsers);
    }
    handleSearchChange = (event) => {
        clearTimeout(this.searchTimer);
        this.setState({ search: event.target.value, page: 0 });
        this.searchTimer = setTimeout(this.loadUsers, 400);
    }
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadUsers);
    }
    openConfirm = (role, username, name) => {
        if (username.trim() === '') {
            this.props.enqueueSnackbar('Please enter username.', { variant: 'error' });
            return;
        }
        this.setState({ confirmUser: { role: role, username: username.trim(), name: name }, reason: '', reasonError: '' });
    }
    closeConfirm = () => {
        this.setState({ confirmUser: null });
    }
    loginAs = () => {
        let self = this;
        const reason = this.state.reason.trim();
        if (reason.length < 5) {
            this.setState({ reasonError: 'Please enter a reason (at least 5 characters).' });
            return;
        }
        // window must be opened in the click itself, else browser blocks it as popup
        const winName = 'c365_login_' + Date.now();
        const loginWindow = window.open('about:blank', winName);
        if (!loginWindow) {
            this.props.enqueueSnackbar('Please allow popups for this site and try again.', { variant: 'error' });
            return;
        }
        const user = this.state.confirmUser;
        this.setState({ isSubmitting: true });
        axios.post(Config.apiBaseURL + '/tenant/impersonate_login/' + this.props.tenantId, { role: user.role, username: user.username, reason: reason })
        .then(response => {
            // token lives 60 seconds and works once - post it right away, never keep it
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = response.data.actionUrl;
            form.target = winName;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'token';
            input.value = response.data.token;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            self.setState({ confirmUser: null });
            self.loadLogs();
        })
        .catch(function (error) {
            loginWindow.close();
            self.handleError(error, 'Error! While logging in as user.');
        })
        .then(function () {
            self.setState({ isSubmitting: false });
        });
    }
    render() {
        let userRows;
        if (this.state.isLoading) {
            userRows = <TableRow><TableCell colSpan={4}><Loader type='inline' /></TableCell></TableRow>;
        } else if (this.state.users.length === 0) {
            userRows = <TableRow><TableCell colSpan={4}>No users found.</TableCell></TableRow>;
        } else {
            userRows = this.state.users.map(user =>
                <TableRow key={user.id}>
                    <TableCell>
                        {user.name}
                        {user.main_admin === 1 ? <Chip label='Main admin' size='small' className="chipEffect" style={{ marginLeft: 8, backgroundColor: '#3f51b5' }} /> : ''}
                    </TableCell>
                    <TableCell>{user.username}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                        <Button size='small' variant='outlined' color='primary' onClick={this.openConfirm.bind(this, this.state.role, user.username, user.name)}>Login as</Button>
                    </TableCell>
                </TableRow>
            );
        }

        const logSearch = this.state.logSearch.trim().toLowerCase();
        const logs = this.state.logs.filter(log =>
            (this.state.logRole === '' || log.role === this.state.logRole) &&
            (logSearch === '' || [log.operator_email, log.username, log.reason].some(value => (value || '').toLowerCase().indexOf(logSearch) !== -1))
        );

        const confirmUser = this.state.confirmUser;
        const confirmDialog = <Dialog open={confirmUser !== null} onClose={this.closeConfirm}>
            <DialogTitle>Login as user</DialogTitle>
            <DialogContent>
                {confirmUser !== null ? <DialogContentText>
                    You are about to log in to {this.props.instituteName} as <b>{confirmUser.name || confirmUser.username}</b> ({roleLabel(confirmUser.role)}, username: {confirmUser.username}). This is recorded.
                </DialogContentText> : ''}
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    margin='normal'
                    variant='outlined'
                    label='Reason (e.g. support ticket number)'
                    value={this.state.reason}
                    onChange={(event) => this.setState({ reason: event.target.value, reasonError: '' })}
                    error={this.state.reasonError !== ''}
                    helperText={this.state.reasonError}
                    inputProps={{ maxLength: 500 }}
                />
            </DialogContent>
            <DialogActions style={{ padding: "24px" }}>
                <Button variant='contained' color='primary' disabled={this.state.isSubmitting} onClick={this.loginAs}>{this.state.isSubmitting ? 'Logging in...' : 'Login'}</Button>
                <Button variant='contained' onClick={this.closeConfirm}>Cancel</Button>
            </DialogActions>
        </Dialog>;

        return (
            <div style={{ fontSize: 14 }}>
                <Typography variant='h6'>Users</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.role} onChange={this.handleRoleChange} label="Role">
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Search name / username / email" value={this.state.search} onChange={this.handleSearchChange} />
                    </Grid>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>{userRows}</TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                count={this.state.total}
                                rowsPerPage={this.state.perPage}
                                page={this.state.page}
                                onPageChange={this.handleChangePage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>

                <Divider style={{ marginTop: 20, marginBottom: 20 }}></Divider>
                <Typography variant='h6'>Login by username</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.manualRole} onChange={(event) => this.setState({ manualRole: event.target.value })} label="Role">
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Username" value={this.state.manualUsername} onChange={(event) => this.setState({ manualUsername: event.target.value })} />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Button variant='contained' color='primary' onClick={() => this.openConfirm(this.state.manualRole, this.state.manualUsername, '')}>Login as</Button>
                    </Grid>
                </Grid>

                <Divider style={{ marginTop: 20, marginBottom: 20 }}></Divider>
                <Typography variant='h6'>Login history</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.logRole} onChange={(event) => this.setState({ logRole: event.target.value })} label="Role">
                                <MenuItem value=''>All</MenuItem>
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Search by / username / reason" value={this.state.logSearch} onChange={(event) => this.setState({ logSearch: event.target.value })} />
                    </Grid>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>By</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Reason</TableCell>
                            <TableCell>IP</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logs.length === 0 ? <TableRow><TableCell colSpan={6}>{this.state.logs.length === 0 ? 'No logins yet.' : 'No matching logins.'}</TableCell></TableRow> :
                            logs.map(log =>
                                <TableRow key={log.id}>
                                    <TableCell>{moment(log.created).format('DD MMM YYYY hh:mm A')}</TableCell>
                                    <TableCell>{log.operator_email}</TableCell>
                                    <TableCell>{roleLabel(log.role)}</TableCell>
                                    <TableCell>{log.username}</TableCell>
                                    <TableCell><div className="TableWordBreak">{log.reason}</div></TableCell>
                                    <TableCell>{log.operator_ip}</TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                </Table>
                {confirmDialog}
            </div>
        );
    }
}

export default withSnackbar(LoginAs);
